export default __webpack_public_path__ + "static/media/icons8-hammer-and-anvil.4d8bf8f3.svg";